import { useContext } from "react";
import { InvoicesTableContext } from "./InvoicesTableContext";

export const useInvoicesTableContext = () => {
  const context = useContext(InvoicesTableContext);
  if (!context) {
    throw new Error(
      "useInvoicesTableContext must be used within an InvoicesTableProvider"
    );
  }
  return context;
};
